import { fabric } from 'fabric'

const defaultWidth = 250
const defaultHeight = 250
const textPadding = 25
const boxPadding = 20
const fontSize = 30

const newBox = function () {
  const box = new fabric.Rect({
    left: 0,
    width: defaultWidth,
    height: defaultHeight,
    strokeWidth: 0,
    fill: '#FFFFA5'
  })

  box.setShadow({
    color: '#999999',
    blur: 10,
    offsetX: 2,
    offsetY: 2
  })

  return box
}

const newText = function (canvas) {
  return new fabric.Textbox('', {
    fill: '#000000',
    fontFamily: 'Arial',
    fontSize: fontSize,
    textAlign: 'left',
    width: defaultWidth - textPadding
  })
}

export default {
  type: 'note',

  isA: function (object) {
    return object.customType === this.type
  },

  new: function () {
    const box = newBox()
    const text = newText()

    const group = new fabric.Group([box], {
      customType: this.type,
      left: 20,
      top: 20,
      width: box.width + boxPadding,
      height: box.height + boxPadding
    })

    text.set({
      left: box.left + (textPadding / 2),
      top: box.top + (textPadding / 2)
    })
    group.add(text)

    return group
  },

  getBox: function (note) {
    return note.getObjects('rect')[0]
  },

  getText: function (note) {
    return note.getObjects('textbox')[0]
  },

  adjustNoteSize: function (note, text, box) {
    const maxWidth = note.width - boxPadding - textPadding
    if (text.width > maxWidth) {
      note.set({
        width: text.width + boxPadding + textPadding
      })

      box.set({
        left: -(note.width - boxPadding) / 2,
        width: note.width - boxPadding
      })
    }

    const maxHeight = note.height - boxPadding - textPadding
    if (text.height > maxHeight) {
      note.set({
        height: text.height + boxPadding + textPadding
      })

      box.set({
        top: -(note.height - boxPadding) / 2,
        height: note.height - boxPadding
      })
    }
  },

  editText: function (note, canvas, ignoreKey, doneCallback) {
    const box = this.getBox(note)
    const text = this.getText(note)

    text.on('changed', () => {
      this.adjustNoteSize(note, text, box)
    })

    text.on('editing:exited', () => {
      text.off('changed')
      text.off('editing:exited')

      canvas.remove(text)
      this.adjustNoteSize(note, text, box)
      text.set({
        left: box.left + (textPadding / 2),
        top: box.top + (textPadding / 2),
        angle: 0
      })
      note.add(text)

      if (doneCallback) {
        doneCallback()
      }
    })

    // if the note is new, mark the text to prevent it from persisting
    text.isNew = note.key === ignoreKey
    text.parent = note

    note.realizeTransform(text)
    note.remove(text)

    text.key = ignoreKey
    canvas.add(text)

    // move the selection to the end of the text
    text.setSelectionStart(text.text.length)
    text.setSelectionEnd(text.text.length)

    canvas.setActiveObject(text)
    text.enterEditing()

    // fix for issue where you can no longer enter text
    // not clear why this fixes the issue
    if (text.hiddenTextarea) {
      text.hiddenTextarea.style.lineHeight = 'initial'
    }
  },

  isEmpty: function (note) {
    return this.getText(note).text.length === 0
  },

  setTextColour: function (note, colour) {
    this.getText(note).setColor(colour)
  },

  setNoteColour: function (note, colour) {
    this.getBox(note).setColor(colour)
  },

  scale: function (note) {
    const width = Math.max(note.getScaledWidth(), defaultWidth + boxPadding)
    const height = Math.max(note.getScaledHeight(), defaultHeight + boxPadding)

    note.set({
      width: width,
      height: height,
      scaleX: 1,
      scaleY: 1
    })

    const box = this.getBox(note)
    box.set({
      left: -(width - boxPadding) / 2,
      top: -(height - boxPadding) / 2,
      width: width - boxPadding,
      height: height - boxPadding
    })

    const text = this.getText(note)
    text.set({
      width: box.width - textPadding
    })

    this.adjustNoteSize(note, text, box)

    text.set({
      left: box.left + (textPadding / 2),
      top: box.top + (textPadding / 2)
    })
  }
}
